import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import AuthGuard from "@/components/AuthGuard";
import AppLayout from "@/layouts/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Registrations from "@/pages/Registrations";
import UploadRegistrations from "@/pages/UploadRegistrations";
import Students from "@/pages/Students";
import CheckinTransactions from "@/pages/CheckinTransactions";
import StudentCheckin from "@/pages/StudentCheckin";
import GuestCheckin from "@/pages/GuestCheckin";
import PartyCheckin from "@/pages/PartyCheckin";
import SequenceConfig from "@/pages/SequenceConfig";
import Backstage from "@/pages/Backstage";
import Announcer from "@/pages/Announcer";
import ScanApp from "@/pages/ScanApp";
import StudentPortal from "@/pages/StudentPortal";
import StudentPrograms from "@/pages/master/StudentPrograms";
import Entities from "@/pages/master/Entities";
import Specializations from "@/pages/master/Specializations";
import StudentCategories from "@/pages/master/StudentCategories";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Full-screen pages (no sidebar) */}
          <Route path="/announcer" element={<Announcer />} />
          <Route path="/scan" element={<ScanApp />} />
          <Route path="/pass" element={<StudentPortal />} />
          <Route path="/convocation" element={<Navigate to="/pass" replace />} />

          {/* App shell */}
          <Route element={<AuthGuard />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/registrations" element={<Registrations />} />
            <Route path="/upload" element={<UploadRegistrations />} />
            <Route path="/students" element={<Students />} />
            <Route path="/checkin-transactions" element={<CheckinTransactions />} />
            <Route path="/checkin/student" element={<StudentCheckin />} />
            <Route path="/checkin/guest" element={<GuestCheckin />} />
            <Route path="/checkin/party" element={<PartyCheckin />} />
            <Route path="/master/programs" element={<StudentPrograms />} />
            <Route path="/master/entities" element={<Entities />} />
            <Route path="/master/specializations" element={<Specializations />} />
            <Route path="/master/categories" element={<StudentCategories />} />
            <Route path="/sequence" element={<SequenceConfig />} />
            <Route path="/backstage" element={<Backstage />} />
          </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}
